import Vue from '~/main.js';
import axios from 'axios';
import { getDomainName, objectToQueryString } from '~/utils/urlUtils';

export default class GoogleFlow {
    /**
     * Redirects to accounts.google.com and logs in a user to the site
     */
    static async startAuthFlow(redirectPath, redirectQuery) {
        const clientId = process.env.VUE_APP_GOOGLE_CLIENT_ID;
        const state =
            getDomainName() +
            (redirectPath ? encodeURIComponent(redirectPath) : '/redirect') +
            (redirectQuery && !redirectPath
                ? objectToQueryString(redirectQuery)
                : '');
        const scope = 'email%20profile';
        const redirectUri = this.redirectUri();

        window.open(
            `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${clientId}&scope=${scope}&state=${state}&redirect_uri=${redirectUri}&include_granted_scopes=true`,
            '_self'
        );
    }

    static async getAccessToken(authCode) {
        const state = getDomainName(); // Is necassary for storing which platform was used during registration
        return axios({
            method: 'GET',
            url: `${
                process.env.VUE_APP_IDENTITY_SERVER_URL
            }user/authenticate-google/?code=${authCode}&state=${state}`,
        });
    }

    static redirectUri() {
        return ''.concat(
            process.env.VUE_APP_IDENTITY_SERVER_URL,
            'user/authenticate-google/callback'
        );
    }
}
